(function () {
  const initProductAccordion = () => {
		$(".about__accordion-toggle:not(.reviews__toggle)").click(function () {
			if (!$(this).hasClass("active")) {
				$(this).addClass("active");
				$(this)
					.siblings(".about__accordion-description")
					.eq($(this).index())
					.stop()
					.slideDown(300);
			} else {
				$(this).removeClass("active");
				$(this).siblings(".about__accordion-description").stop().slideUp(300);
			}
		});
  };

  const initZoomImage = () => {
    const imagesWrapper = document.querySelector('.product-media-modal__content');
    const images = imagesWrapper.querySelectorAll('.js-image-zoom');

    images.forEach(el => {
      el.addEventListener('click', (e) => {
        imagesWrapper.classList.toggle('zoom');
      });
    })
  };

  const initStyleSlider = () => {
    const sliders = document.querySelectorAll('.style__slider');

    sliders.forEach((slider, index) => {
      const articlesSlider = new Swiper(slider, {
        slidesPerView: 3,
        spaceBetween: 8,
        navigation: {
          nextEl: ".style__slider-nav .swiper-button-next",
          prevEl: ".style__slider-nav .swiper-button-prev",
        },
        breakpoints: {
          1024: {
            slidesPerView: 4,
            slidesPerGroup: 4
          }
        }
      })
    })
  }

  const initRangeSlider = () => {
    const sliders = document.querySelectorAll('.range__slider');

    sliders.forEach((slider, index) => {
      const articlesSlider = new Swiper(slider, {
        slidesPerView: 3,
        spaceBetween: 8,
        navigation: {
          nextEl: ".range__slider-nav .swiper-button-next",
          prevEl: ".range__slider-nav .swiper-button-prev",
        },
        breakpoints: {
          1024: {
            slidesPerView: 4,
            slidesPerGroup: 4
          }
        }
      })
    })
  }

  function updateSlideWidths() {
    setTimeout(() => {
      const slides = document.querySelectorAll(
        '.product__outer--static-column-aside .js-media-list-mobile .swiper-wrapper .swiper-slide'
      );
    
      if (!slides.length) return;
    
      const secondActive = slides[1]?.classList.contains('active');
      const thirdActive = slides[2]?.classList.contains('active');
      // 1st slide
      slides[0].classList.toggle('half-width', secondActive || thirdActive);
      slides[0].classList.toggle('full-width', !(secondActive || thirdActive));
      // 2nd slide
      if (slides[1]) {
        slides[1].classList.toggle('full-width', secondActive);
        slides[1].classList.toggle('half-width', !secondActive);
      }
    
      // 3rd slide
      if (slides[2]) {
        slides[2].classList.toggle('full-width', thirdActive);
        slides[2].classList.toggle('half-width', !thirdActive);
      }
    }, 0);
  }
  
  // Call this function whenever a variant changes
  document.querySelectorAll('.product-form__controls-group input').forEach(selector => {
    selector.addEventListener('change', () => {
      updateSlideWidths();
    });
  });
  
  

  

  document.addEventListener('shopify:section:load', function () {
    initProductAccordion();
    initZoomImage();
    updateSlideWidths();
  });

  initProductAccordion();
  initZoomImage();
  initStyleSlider();
  initRangeSlider();
})();
